import React from 'react';
import { Box, Typography } from '@mui/material';
import { Check } from '@mui/icons-material';
import { Confetti, PrimaryButton, ScreenShell, ScreenTitle, tokens } from '../parts';
import { GoalFlowScreenProps } from './types';

/** "Goal Set!" — shown once the goal is saved; "View My SMART Goal" returns to the dashboard. */
export const SuccessScreen: React.FC<GoalFlowScreenProps> = ({ goalFlow }) => (
  <ScreenShell
    overlay={<Confetti />}
    footer={<PrimaryButton onClick={goalFlow.finish}>View My SMART Goal</PrimaryButton>}
  >
    <Box
      sx={{
        minHeight: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 3.5,
        pt: 4,
      }}
    >
      <Box
        sx={{
          width: 80,
          height: 80,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Check sx={{ color: '#fff', fontSize: 40 }} />
      </Box>
      <Box sx={{ textAlign: 'center', display: 'flex', flexDirection: 'column', gap: 1 }}>
        <ScreenTitle large>Goal Set!</ScreenTitle>
        <Typography sx={{ fontSize: '15px', color: tokens.textPrimary, lineHeight: 1.6 }}>
          You&apos;ve taken the first step. Your goal runs {goalFlow.goalStartLabel} – {goalFlow.goalEndLabel}.
        </Typography>
      </Box>
      <Box
        sx={{
          width: '100%',
          background: tokens.surface,
          borderRadius: '16px',
          border: `1px solid ${tokens.borderSubtle}`,
          p: 2,
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
        }}
      >
        <Typography
          sx={{
            fontSize: '12px',
            fontWeight: 700,
            color: tokens.label,
            textTransform: 'uppercase',
            letterSpacing: '0.15em',
          }}
        >
          Your Commitments
        </Typography>
        {goalFlow.cards.map((card) => (
          <Box key={card.index} sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
            <Box
              sx={{
                width: 20,
                height: 20,
                borderRadius: '50%',
                background: card.color,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexShrink: 0,
              }}
            >
              <Check sx={{ color: '#fff', fontSize: 12 }} />
            </Box>
            <Typography sx={{ fontSize: '15px', color: tokens.textPrimary, lineHeight: 1.4 }}>
              <strong>{card.name}</strong> — {card.frequency}× / week, {card.duration} min
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  </ScreenShell>
);
